import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { interval } from 'rxjs';
import { debounce, distinctUntilChanged, pairwise, startWith } from 'rxjs/operators';
import { EventEmitterService } from 'src/modules/shared/services/event-emitter.service';
import { GroupConfigurationKey } from '../../models/group-keys.model';
import { WordDataTypeEnum } from '../../models/enums/word-data-type.enum';

@Component({
  selector: 'hcr-dynamic-form-input',
  templateUrl: './dynamic-form-input.component.html',
  styleUrls: ['./dynamic-form-input.component.sass'],
})
export class DynamicFormInputComponent implements OnInit, OnDestroy {
  @Input() configurationKey!: GroupConfigurationKey;
  @Input() form!: FormGroup;
  @Input() debounceTime = 0;
  @Output() clearInput = new EventEmitter<{ key: GroupConfigurationKey; inputForm: AbstractControl }>();
  @Output() valueChanges: EventEmitter<{ key: GroupConfigurationKey; inputForm: AbstractControl }> = new EventEmitter();

  public formSuccessFeedback: { [key: string]: boolean } = {};
  public wordDataTypeEnum = WordDataTypeEnum;

  public get isValid(): boolean {
    return this.form.controls[this.configurationKey.key].valid;
  }

  constructor(public eventEmitterService: EventEmitterService, private readonly _changeDetectorRef: ChangeDetectorRef) {}

  public clearValue(): void {
    this.form.controls[this.configurationKey.key].setValue(null);
    this._highlightForm(this.configurationKey.key);

    this.clearInput.emit({ key: this.configurationKey, inputForm: this.form.controls[this.configurationKey.key] });
  }

  private _highlightForm(key: string): void {
    this.formSuccessFeedback[key] = true;

    setTimeout(() => {
      this.formSuccessFeedback[key] = false;
    }, 100);
  }

  ngOnInit(): void {
    this.form.addControl(this.configurationKey.key, new FormControl());

    if (this.configurationKey.required) {
      this.form.controls[this.configurationKey.key].setValidators(Validators.required);
    }

    this.form.controls[this.configurationKey.key].updateValueAndValidity();

    this.form.controls[this.configurationKey.key].valueChanges
      .pipe(
        startWith(this.form.controls[this.configurationKey.key].value),
        pairwise(),
        distinctUntilChanged(),
        debounce(() => interval(this.debounceTime))
      )
      .subscribe(([old, value]) => {
        if (old !== value) {
          this.valueChanges.emit({ key: this.configurationKey, inputForm: this.form.controls[this.configurationKey.key] });
          this._highlightForm(this.configurationKey.key);
        }
      });
  }

  ngOnDestroy(): void {
    this.form.removeControl(this.configurationKey.key);
  }
}
